import { render, staticRenderFns } from "./DeleteRecurringAppointmentSeriesModal.vue?vue&type=template&id=a8b52564&scoped=true&class=fill-height&"
import script from "./DeleteRecurringAppointmentSeriesModal.vue?vue&type=script&lang=ts&"
export * from "./DeleteRecurringAppointmentSeriesModal.vue?vue&type=script&lang=ts&"
import style0 from "./DeleteRecurringAppointmentSeriesModal.vue?vue&type=style&index=0&id=a8b52564&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8b52564",
  null
  
)

export default component.exports